const types = {
  FETCH_PRODUCT_SCHEDULE: "FETCH_PRODUCT_SCHEDULE",
  UPDATE_COPY_SCHED: "UPDATE_COPY_SCHED"
};

export default types;
